import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';
import CloseButton from '../CloseButton/CloseButton';

const HeaderContainer = ({ children }) => (
  <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={2} sx={{ gap: 2 }}>
    {children}
  </Box>
);

const HeaderTitle = (props) => (
  <Typography
    {...props}
    sx={{
      fontWeight: 500,
      flex: '1 1 auto',
      minWidth: 0,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    }}
  />
);

function Contact() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, position: 'relative' }}>
        <HeaderContainer>
          <HeaderTitle variant="h3" component="h1">
            {t('contactTitle')}
          </HeaderTitle>
          <CloseButton
            onClick={() => navigate('/')}
            size="small"
            color="primary"
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
          />
        </HeaderContainer>
        
        <Typography variant="body1" paragraph align="center" sx={{ mt: 3 }}>
          {t('contactIntro')}
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <EmailIcon color="primary" />
            <Box>
              <Link href="mailto:contact-standstrong@protonmail.com" underline="hover">
                contact-standstrong@protonmail.com
              </Link>
            </Box>
          </Box>

        
        </Box>

        <Box
          sx={{
            mt: 4,
            p: 2.5,
            borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Typography variant="h6" gutterBottom>
            {t('feedbackTitle')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('feedbackText')}
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 3,
            p: 2.5,
            borderRadius: 2,
            bgcolor: 'rgba(34,211,238,0.16)',
            border: '1px solid rgba(34,211,238,0.35)',
            color: '#0b1021',
            textAlign: 'center',
            boxShadow: '0 12px 30px rgba(34,211,238,0.25)',
          }}
        >
          <Typography variant="body2" fontWeight={700}>
            {t('responseTimeText')}
          </Typography>
        </Box>

      </Paper>
    </Container>
  );
}

export default Contact;
